module.exports = __webpack_public_path__ + "images/emoji/clock12.2c88eedb5a458036d4c6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock12.png
// module id = 58Ew
// module chunks = 1